export default __webpack_public_path__ + "static/regga-sig-pp-4bbc30a19041c967f74f3faad4cf86cc.png";